import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout route: the recipients list moved to `recipients/list` so the section
// can host sub-pages (гемотрансфузии, ...).
export const Route = createFileRoute('/_protected/recipients')({
  component: () => <Outlet />,
})
